/*
描述:用户考核系统主线js
时间:2017-12-3
作者:bai.zhiming
 */
"use strict";
var app = angular.module("ugc", [
    'validation',
    'validation.rule',
    'treeControl',
    'ui.calendar',
    'LocalStorageModule',
    'ui.router',
    'ui.bootstrap',
    'components.utils',
    'cgBusy',
    'ngFileUpload',
    'ugcRouterModule',
    'mainModule',
    'loginModule',
    'dndLists'
]);
angular.element(document)
    .ready(function() {
        angular.bootstrap(document, ['ugc']);
    });
app.value('cgBusyDefaults', {
    message: '数据加载中...',
    backdrop: true,
    delay: 0,
    minDuration: 100,
    wrapperClass: 'mlf-busy'
});